import * as React from "react";
import Paper from "@mui/material/Paper";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TablePagination from "@mui/material/TablePagination";
import TableRow from "@mui/material/TableRow";
import IconButton from "@mui/material/IconButton";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import Button from "@mui/material/Button";
import VisibilityIcon from "@mui/icons-material/Visibility";
import Header from "components/Header";
import { useTheme } from "@mui/material/styles";
import { toast } from "react-toastify";
import { Box, Dialog, DialogTitle, DialogActions } from "@mui/material";
import { getAllProperties, deletePaymentVoucher, getAllPaymentVoucher } from "state/apis";
// import Add from "./Add";
import { InputBase } from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
// import Expense from "./Expense";
import { GiWallet } from "react-icons/gi";
import DefaultProperty from "components/DefaultProperty";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { getDefaultProperty } from "state";
import moment from "moment";
import VoucherDetails from "./PaymentVoucherDetails";
import PaymentVoucherDetails from "./PaymentVoucherDetails";

const PaymentVoucher = () => {
    const theme = useTheme();
    const [isLoading, setIsLoading] = React.useState(true);
    const [data, setData] = React.useState([]);
    console.log("data: ", data);
    const [totalData, setTotalData] = React.useState([]);
    const [openPopup, setOpenPopup] = React.useState(false);
    const [openDefaultProperty, setOpenDefaultProperty] = React.useState(false);
    const [selectedRow, setSelectedRow] = React.useState(null);
    const [deleteConfirmationOpen, setDeleteConfirmationOpen] = React.useState(false);
    const [deleteItem, setDeleteItem] = React.useState(null);
    const [page, setPage] = React.useState(0);
    const [rowsPerPage, setRowsPerPage] = React.useState(50);
    const [property, setProperty] = React.useState([]);
    const [searchQuery, setSearchQuery] = React.useState("");
    const inputRef = React.useRef(null);
    const defaultProperty = useSelector((state) => state.global.defaultProperty);
    const dispatch = useDispatch();
    const [role, setRole] = React.useState({});
    const [isSoldProperty, setIsSoldProperty] = React.useState(false);

    React.useEffect(() => {
        fetchData();
        fetchRole();
        if (!defaultProperty) {
            setOpenDefaultProperty(true);
        }
    }, [page, rowsPerPage, searchQuery]);

    const fetchRole = async () => {
        const res = await getDefaultProperty(dispatch);
        setIsSoldProperty(res?.data?.property?.isSold);

        if (res?.data?.role && res?.data?.role?.permission) {
            setRole(JSON.parse(res?.data?.role?.permission));
        }
    };

    const fetchData = async () => {
        try {
            const res = await getAllPaymentVoucher(rowsPerPage, page * rowsPerPage, searchQuery);
            setData(res?.voucher);
            setTotalData(res?.totalCount);
            setIsLoading(false);
        } catch (error) {
            console.error("Error fetching data:", error);
            toast.error("Failed to fetch data. Please try again.");
        }
    };

    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(+event.target.value);
        setPage(0);
    };

    const handleOpenPopup = (row) => {
        setSelectedRow(row);
        setOpenPopup(true);
    };

    // const handleCloseAddForm = () => {
    //     setOpenAddForm(false);
    // };

    // const handleSubmitAddFlats = async () => {
    //     setOpenAddForm(false);
    //     setSelectedRow(null);
    //     setIsLoading(true);
    //     fetchData();
    // };

    // const handleEditClick = (row) => {
    //     setSelectedRow(row);
    //     setOpenAddForm(true);
    // };

    const handleDeleteClick = (row) => {
        setDeleteItem(row?.id);
        setDeleteConfirmationOpen(true);
    };

    const handleCloseDefaultProperty = () => {
        setOpenDefaultProperty(false);
    };

    const handleDeleteConfirmation = async () => {
        try {
            await deletePaymentVoucher(deleteItem);
            toast.success("Payment voucher deleted successfully.");
            fetchData();
            setDeleteConfirmationOpen(false);
        } catch (error) {
            console.error("Error deleting voucher:", error);
            toast.error("Failed to delete voucher. Please try again.");
        }
    };

    const handleSearchChange = (event) => {
        setSearchQuery(event.target.value);
    };

    const handleSearch = () => {
        fetchData();
    };

    const focusInput = () => {
        inputRef.current.focus();
    };

    if (isLoading) {
        return (
            <Box sx={{ p: "24px 28px" }}>
                <Header title="Payment Voucher" />
                <Box sx={{ mt: 4, textAlign: "center", color: "#5a6a85" }}>Loading...</Box>
            </Box>
        );
    }

    return (
        <Box sx={{ p: "24px 28px" }}>
            <Header title="Payment Voucher" subtitle="List of Payment Voucher" />
            <Paper sx={{ width: "100%", overflow: "hidden", mt: 2.5, borderRadius: "12px", boxShadow: "0 1px 3px rgba(0,0,0,0.06)" }}>
                <Box display="flex" justifyContent="flex-end" p={2}>
                    <InputBase
                        placeholder="Search..."
                        sx={{ backgroundColor: "#eef1f6", borderRadius: "8px", px: 1.5, py: 0.5, fontSize: "0.8125rem", width: 200 }}
                        inputRef={inputRef}
                        value={searchQuery}
                        onChange={handleSearchChange}
                        onFocus={focusInput}
                    />
                    <IconButton onClick={handleSearch}>
                        <SearchIcon />
                    </IconButton>
                </Box>
                <TableContainer
                    sx={{ maxHeight: 900 }}
                >
                    <Table stickyHeader size="small">
                        <TableHead>
                            <TableRow>
                                <TableCell>Date</TableCell>
                                <TableCell>Property Name</TableCell>
                                <TableCell>Owner Name</TableCell>
                                <TableCell>Note</TableCell>
                                <TableCell>Total Amount</TableCell>
                                <TableCell>Description</TableCell>
                                <TableCell>View</TableCell>
                                {role?.voucherReceipt?.delete && !isSoldProperty && (
                                    <TableCell>Actions</TableCell>
                                )}
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {data.map((row) => (
                                <TableRow hover role="checkbox" tabIndex={-1} key={row.id}>
                                    <TableCell>
                                        {row?.date ? moment(row?.date).format("DD/MM/YYYY") : ""}
                                    </TableCell>
                                    <TableCell>{row?.property?.propertyName}</TableCell>
                                    <TableCell>{row?.property?.owner?.name}</TableCell>
                                    <TableCell>{row?.note}</TableCell>
                                    <TableCell>{row.totalAmount}</TableCell>
                                    <TableCell>{row?.description}</TableCell>
                                    <TableCell>
                                        <IconButton
                                            onClick={() => {
                                                handleOpenPopup(row);
                                            }}
                                        >
                                            <VisibilityIcon />
                                        </IconButton>
                                    </TableCell>

                                    {role?.voucherReceipt?.delete && !isSoldProperty && (
                                        <TableCell>
                                            <IconButton
                                                color="error"
                                                onClick={() => handleDeleteClick(row)}
                                            >
                                                <DeleteIcon />
                                            </IconButton>
                                        </TableCell>
                                    )}
                                </TableRow>
                            ))}
                        </TableBody>
                    </Table>
                </TableContainer>
                <TablePagination
                    rowsPerPageOptions={[10, 25, 50, 100]}
                    component="div"
                    count={totalData}
                    rowsPerPage={rowsPerPage}
                    page={page}
                    onPageChange={handleChangePage}
                    onRowsPerPageChange={handleChangeRowsPerPage}
                />
                <PaymentVoucherDetails
                    open={openPopup}
                    onClose={() => setOpenPopup(false)}
                    // onSubmit={handleSubmitAddFlats}
                    editData={selectedRow}
                    editMode={!!selectedRow}
                    property={property}
                />

                {!defaultProperty && (
                    <DefaultProperty
                        open={openDefaultProperty}
                        onClose={() => handleCloseDefaultProperty}
                    />
                )}
                <Dialog
                    open={deleteConfirmationOpen}
                    onClose={() => setDeleteConfirmationOpen(false)}
                >
                    <DialogTitle fontWeight={"bold"}>Are you sure you want to delete?</DialogTitle>
                    <DialogActions>
                        <Button
                            onClick={() => setDeleteConfirmationOpen(false)}
                            sx={{ color: "#5a6a85" }}
                        >
                            Cancel
                        </Button>
                        <Button onClick={handleDeleteConfirmation} color="error" autoFocus>
                            Delete
                        </Button>
                    </DialogActions>
                </Dialog>
            </Paper>
        </Box>
    );
};

export default PaymentVoucher;
